
import { mapGetters } from 'vuex';

import HorizontalSearchItem from './HorizontalSearchItem.vue';

export default {
  name: 'InfiniteSearchListItem',
  components: { HorizontalSearchItem },
  props: {
    searchItem: { type: Object, required: true },
    index: { type: Number, required: true },
    isFromNoFilterSearchList: { type: Boolean, default: false },
  },
  computed: {
    ...mapGetters('search', ['currentPage']),
  },
  mounted() {
    this.iob = new IntersectionObserver(
      entires => {
        if (entires[0].isIntersecting) {
          if (!this.$refs[`trigger_${this.currentPage}`]) return;
          this.$emit('add-fetch');
          this.iob.unobserve(this.$refs[`trigger_${this.currentPage}`]); // 패치 후, 관찰 대상에서 제외
        }
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 1.0,
      },
    );

    this.$refs[`trigger_${this.currentPage}`] &&
      this.iob.observe(this.$refs[`trigger_${this.currentPage}`]);
  },
};
